import { useEffect, useState } from 'react';
import '../styles/dashboard.css';
import api from '../services/api';
import { useNavigate } from "react-router-dom";
import GraphComponent from './Graph/GraphComponent';

const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

const getToday = () => formatDate(new Date());

const getOneMonthBack = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return formatDate(date);
};


const DefaultDashboard = () => {
  const [topCounts, setTopCounts] = useState({total: 0,active: 0,inactive: 0,});
  const [topumrahCounts, setTopumrahCounts] = useState({total_package: 0,active_packages: 0,inactive_packages: 0,expired_packages: 0,live_packages: 0});
  const [tophajjCounts, setTophajjCounts] = useState({total_package: 0,active_packages: 0,inactive_packages: 0,expired_packages: 0,live_packages: 0});

  const navigate = useNavigate();

useEffect(() => {
  fetchTopCounts();
  fetchTopumrahcount();
  fetchTophajjcount();
}, []);

  // --------------------
  // API CALL
  // --------------------

const fetchTopCounts = async () => {
  try {
    const res = await api.get('/dashboard/topcount');
    console.log('Top count response:', res.data);

    // Adjust keys based on your API response
setTopCounts({
  total: res?.data?.data?.total_users ?? 0,
  active: res?.data?.data?.active_users ?? 0,
  inactive: res?.data?.data?.inactive_users ?? 0,
});
  } catch (error) {
    console.error('Top count API error:', error);
  }
};

const fetchTopumrahcount = async () => {
  try {
    const res = await api.get('/dashboard/umrahpackgecount');
    console.log('Top count umra response:', res.data);

    // Adjust keys based on your API response
setTopumrahCounts({
  total_package: res?.data?.data?.total_packages ?? 0,
  active_packages: res?.data?.data?.active_packages ?? 0,
  inactive_packages: res?.data?.data?.inactive_packages ?? 0,
  expired_packages: res?.data?.data?.expired_packages ?? 0,
  live_packages: res?.data?.data?.live_packages ?? 0,


});
  } catch (error) {
    console.error('Top count API error:', error);
  }
};

const fetchTophajjcount = async () => {
  try {
    const res = await api.get('/dashboard/haajpackgecount');
    console.log('Top count hajj response:', res.data);           
    // Adjust keys based on your API response
    setTophajjCounts({
      total_package: res?.data?.data?.total_packages ?? 0,
      active_packages: res?.data?.data?.active_packages ?? 0,
      inactive_packages: res?.data?.data?.inactive_packages ?? 0,
      expired_packages: res?.data?.data?.expired_packages ?? 0,
      live_packages: res?.data?.data?.live_packages ?? 0,
    });
      } catch (error) {
        console.error('Top count API error:', error);
      }};  



      const handleCardClick = (type, module) => {
        navigate("/tour-opretor", {
          state: { filterType: type, moduleType: module }
        });
      };

      const handleCardPackageClick = (type, module) => {
        if(module === "umrah"){
            navigate("/umrah-packages-list", {
            state: { filterType: type, moduleType: module }
          });
        }
      };

      const handleCardhajjPackageClick = (type, module) => {
        if(module === "hajj"){
            navigate("/hajj-packages-list", {
            state: { filterType: type, moduleType: module }
          });
        }
      };


  return (
    <>
        <GraphComponent/>
      <div className="dashboard-content">
              <div className="top-count-container-nav">
                  <div>
                    <h2 style={{fontSize: '26px', fontWeight: '700', marginBottom: '0px'}}>Tour Operators</h2>
                  </div>
                  <div className="top-count-container">

                    <div className="label-container-count count-card" onClick={() => handleCardClick("total", "tour")}>
                      <p>Total Tour Operators</p>
                      <h3>{topCounts.total}</h3>
                    </div>

                    <div className="label-container-count count-card"onClick={() => handleCardClick("active", "tour")}>
                      <p>Active Tour Operators</p>
                      <h3>{topCounts.active}</h3>
                    </div>

                    <div className="label-container-count count-card " onClick={() => handleCardClick("inactive", "tour")}>
                      <p>Inactive Tour Operators</p>
                      <h3>{topCounts.inactive}</h3>
                    </div>
                  </div>
                </div>

              <div className="top-count-container-nav">
                  <div >
                    <h2 style={{fontSize: '26px', fontWeight: '700', marginBottom: '0px'}}>Umrah Packages</h2>
                  </div>
                  <div className="top-count-container">

                    <div className="label-container-count count-card" onClick={() => handleCardPackageClick("total", "umrah")}>
                      <p>Total Package</p>
                      <h3>{topumrahCounts.total_package}</h3>
                    </div>

                    <div className="label-container-count count-card" onClick={() => handleCardPackageClick("active", "umrah")}>
                      <p>Active Packages</p>
                      <h3>{topumrahCounts.active_packages}</h3>
                    </div>

                    <div className="label-container-count count-card " onClick={() => handleCardPackageClick("inactive", "umrah")}>
                      <p>Inactive Packages</p>
                      <h3>{topumrahCounts.inactive_packages}</h3>
                    </div>
                    <div className="label-container-count count-card " onClick={() => handleCardPackageClick("expired", "umrah")}>
                      <p>Expired Packages</p>
                      <h3>{topumrahCounts.expired_packages}</h3>
                    </div>
                    <div className="label-container-count count-card " onClick={() => handleCardPackageClick("live", "umrah")}>
                      <p>Live Packages</p>
                      <h3>{topumrahCounts.live_packages}</h3>
                    </div>
                  </div>
                </div>

                <div className="top-count-container-nav">     
                  <div >
                    <h2 style={{fontSize: '26px', fontWeight: '700', marginBottom: '0px'}}>Hajj Packages</h2>
                  </div>
                  <div className="top-count-container">
                    <div className="label-container-count count-card" onClick={() => handleCardhajjPackageClick("total", "hajj")}>
                      <p>Total Package</p>
                      <h3>{tophajjCounts.total_package}</h3>
                    </div>  
                    <div className="label-container-count count-card" onClick={() => handleCardhajjPackageClick("active", "hajj")}> 
                      <p>Active Packages</p>
                      <h3>{tophajjCounts.active_packages}</h3>
                    </div>
                    <div className="label-container-count count-card " onClick={() => handleCardhajjPackageClick("inactive", "hajj")}>
                      <p>Inactive Packages</p>
                      <h3>{tophajjCounts.inactive_packages}</h3>
                    </div>
                    <div className="label-container-count count-card " onClick={() => handleCardhajjPackageClick("expired", "hajj")}>
                      <p>Expired Packages</p>
                      <h3>{tophajjCounts.expired_packages}</h3>
                    </div>
                    <div className="label-container-count count-card " onClick={() => handleCardhajjPackageClick("live", "hajj")}>
                      <p>Live Packages</p>
                      <h3>{tophajjCounts.live_packages}</h3>
                    </div>
                  </div>
                </div>
      </div>
    
    </>
  );
};

export default DefaultDashboard;
